import {
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import { colors, DefaultButton } from 'design-system';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorContainer: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      marginTop: 50,
    },
    errorCircle: {
      display: 'inline-block',
      width: 170,
      height: 170,
      borderRadius: 85,
      backgroundColor: '#F5F5F5',
    },
    errorCircleContent: {
      height: '100%',
    },
    errorImage: {
      marginTop: 40,
      marginBottom: 30,
    },
    fontCaption: {
      fontSize: 15,
      lineHeight: '22px',
      marginBottom: '1rem',
    },
    fontTitle: {
      fontSize: 19,
      lineHeight: '24px',
      fontWeight: 900,
    },
    fontSubtitle: {
      fontSize: 15,
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '.1px',
      color: colors.abbey,
    },
  }),
);

type Props = {
  titleMessage?: string;
  captionMessage?: React.ReactNode;
  paymentType?: string;
};

export const defaultTitle = (
  paymentType: string | undefined,
): React.ReactNode =>
  paymentType === 'TCR' ? (
    <span data-testid="tcr-title">
      Lo sentimos, hubo un error en la emisión, hemos REVERSADO el cobro a tu
      tarjeta.
    </span>
  ) : (
    <span data-testid="default-title">
      Ha ocurrido un error en el proceso de emisión.
    </span>
  );

const ErrorLayout = ({
  titleMessage,
  captionMessage,
  paymentType,
}: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.errorContainer}>
      <Grid container justifyContent="center" spacing={3}>
        <Grid item xs={12} sm={6} md={4} container justifyContent="center">
          <Typography variant="h2" align="center" className={classes.fontTitle}>
            {titleMessage !== undefined
              ? titleMessage
              : defaultTitle(paymentType)}
          </Typography>
        </Grid>
        <Grid item xs={12} container justifyContent="center">
          <img
            className={classes.errorImage}
            alt="error"
            src="/images/error_image.svg"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} container justifyContent="center">
          <Typography
            variant="caption"
            align="center"
            className={classes.fontCaption}
          >
            {captionMessage !== undefined ? (
              captionMessage
            ) : (
              <Grid
                xs={12}
                md={9}
                data-testid="whatsapp-button-container"
                style={{ justifySelf: 'center' }}
              >
                Puedes intentar nuevamente.
                <br />
                Si el error persiste, escríbenos al{' '}
                <a
                  id="sales-web-inspection-whatsapp-button"
                  href="https://wa.me/50625032772"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="whatsapp-button"
                  style={{
                    color: colors.bright_turquoise,
                    fontWeight: 700,
                    verticalAlign: 'bottom',
                    textDecoration: 'underline',
                  }}
                >
                  WhatsApp (506) 2503-2772
                </a>{' '}
                para brindarte asistencia
              </Grid>
            )}
          </Typography>

          <Grid item xs={12} md={8}>
            <DefaultButton
              data-testid="reload-button"
              variant="outlined"
              fullWidth
              onClick={() => window.location.reload()}
            >
              Reintentar
            </DefaultButton>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ErrorLayout;
